<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-toolbar dense>
          <choose-resource domain="exam" :includeTypes="searchExamTypes" @selectedFile="loadSelectedFile" />
          <v-btn icon>
            <v-icon>mdi-file-upload-outline</v-icon>
          </v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn-toggle v-model="selectMode">
            <v-btn icon>
              <v-icon>mdi-cursor-default-outline</v-icon>
            </v-btn>
            <v-btn icon>
              <v-icon>mdi-shape-rectangle-plus</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-spacer />
          <v-switch hide-details flat v-model="showAnnotations" label="Show Annotations"></v-switch>
        </v-toolbar>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col lg="8" sm="12" style="text-align: center">
        <v-pagination
          class="mb-5"
          v-model="currentPage"
          :total-visible="10"
          :length="pageCount"
          circle
        ></v-pagination>
        <v-progress-linear v-if="pdfLoading" indeterminate
              color="yellow darken-2"/>
        <div
          ref="pdfContainer"
          v-on:keydown.delete="delAnnotation"
          tabindex="1"
          id="editzone"
          style="position: relative;"
        >
          
          <pdf
            ref="pdfComponent"
            :src="pdfSrc"
            @num-pages="pageCount = $event"
            @page-loaded="pageLoaded"
            :page="currentPage"
          />
          <v-stage
            @mousedown="handleStageMouseDown"
            @touchstart="handleStageMouseDown"
            @mousemove="dragMove"
            @mouseup="handleStageMouseUp"
            @mouseenter="enterStage"
            @mouseleave="leaveStage"
            ref="stage"
            style="position: absolute; top: 0; left: 0"
            :config="configKonva"
          >
            <v-layer ref="annotationLayer" v-if="showAnnotations">
              <v-group
                @transformend="handleTransformEnd"
                @dragend="dragEnd"
                v-for="(rect) in layerAnnotations"
                :key="rect.id"
                :config="{ x: rect.x, y: rect.y, draggable: true}"
              >
                <v-text :config="{text: `${rect.type || 'Misc'} #${rect.number}`, x: 10, y: 10}"></v-text>
                <v-rect
                  @keydown="delAnnotation"
                  @mouseenter="enterRect"
                  @mouseleave="leaveRect"
                  @dblclick="showEditAnnotation = true"
                  :config="{name: rect.name, width: rect.width, height: rect.height, stroke: rect.rect, strokeWidth: rect.strokeWidth, fill: rect.fill, opacity: rect.opacity }"
                ></v-rect>
              </v-group>
              <v-transformer ref="transformer" :config="{rotateEnabled: false}" />
            </v-layer>
            <!-- <v-layer v-if="layerPdfText">
              <v-rect v-for="(text) in pdfTextRects" :key="text.id" :config="text"></v-rect>
              <v-text v-for="(text) in pdfTexts" :key="text.id" :config="text"></v-text>
            </v-layer>-->
          </v-stage>
        </div>
      </v-col>
      <v-col lg="4" sm="12">
        <div class="ml-5">
          <v-toolbar>
            <v-select v-model="selectedType" label="Types" :items="annotationTypes"></v-select>
          </v-toolbar>
          <v-toolbar v-if="selectedType == 'All' || selectedType == 'Question'" class="mt-2">
            <v-select label="Question" :items="allQuestions"></v-select>
          </v-toolbar>
          <v-card
            @click="selectedAnnotationName = `annotation_${annotation.number}`; updateTransformer();"
            class="mt-5"
            v-for=" (annotation) in pageAnnotations "
            :key="annotation.id"
          >
            <v-card-actions class="justify-end">
              <!-- <v-btn @click="linkReferences" icon>
                <v-icon>mdi-file-link-outline</v-icon>
              </v-btn> -->
              <choose-resource domain="exam" activatorIcon="mdi-link" :includeTypes="searchQuestionRefs" @selectedFile="loadSelectedFile" />
              <standard-search
                :key="annotation.id"
                @onOpen="startStandardsSearch"
                @addedStandards="addStandards"
                :grade="grade"
                :subject="subject"
              />

              <v-spacer />
              <v-btn
                @click="selectedAnnotationName = `annotation_${annotation.number}`; showEditAnnotation = true;"
                icon
              >
                <v-icon>mdi-circle-edit-outline</v-icon>
              </v-btn>
              <v-btn
                @click="selectedAnnotationName = `annotation_${annotation.number}`; delAnnotation()"
                icon
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </v-card-actions>
            <v-card-title>{{annotation.type}} {{annotation.number}}</v-card-title>
            <v-card-subtitle>x:{{annotation.position.x}} y: {{annotation.position.y}}</v-card-subtitle>
            <v-card-text>{{annotation.question}}</v-card-text>
          </v-card>

          <v-dialog v-model="showEditAnnotation">
            <v-card v-if="selectedAnnotation" class="py-10">
              <v-card-title>Edit Question</v-card-title>
              <v-card-text>
                <v-select v-model="selectedAnnotation.type" label="Types" :items="annotationTypes"></v-select>
                <v-text-field label="Question #" v-model="selectedAnnotation.number"></v-text-field>
                <v-text-field label="Question" v-model="selectedAnnotation.question"></v-text-field>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn @click="updateAnnotation">Update</v-btn>
                <v-btn @click="showEditAnnotation = false">Cancel</v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-if="!selectedAnnotation" class="py-10">
              <v-card-title>No Questions Selected</v-card-title>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import pdf from "vue-pdf";
import Vue from "vue";
import VueKonva from "vue-konva";
import Konva from "konva";
const StandardSearch = () => import("@/components/standards/StandardSearch.vue");
const ChooseResource = () =>  import("@/components/resourceMgt/ChooseResource.vue");
import PDFJS from 'pdfjs-dist/webpack';

Vue.use(VueKonva);

export default {
  data() {
    return {
      pdfSrc: null,
      pdfLoading: false,
      ctx: null,
      selectMode: 0,
      showEditAnnotation: false,
      showLinkStandards: false,
      grade: 1,
      subject: "Math",
      addingRect: false,
      startPosition: {
        x: null,
        y: null
      },
      currentPage: 1,
      pageCount: 0,
      configKonva: {
        width: 740,
        height: 1200
      },
      selectedAnnotationName: null,
      selectedAnnotation: null,
      showAnnotations: true,
      annotationTypes: [
        "All",
        "Question",
        "Passage",
        "Chart",
        "Image",
        "Formula"
      ],
      selectedType: "All",
      allPagesAnnotations: [
        {
          page: 1,
          width: 0,
          height: 0,
          annotations: [
            {
              id: 1,
              number: 1,
              type: "Question",
              question: "what's your name?",
              position: { x: 10, y: 20, width: 100, height: 50 }
            }
          ]
        }
      ],
      allQuestions: [],
      layerAnnotations: [],
      layerTexts: [],
      rectTemplate: {
        stroke: "#555",
        strokeWidth: 1,
        opacity: 0.2,
        shadowColor: "black",
        shadowBlur: 10,
        shadowOffsetX: 10,
        shadowOffsetY: 10,
        shadowOpacity: 0.2,
        cornerRadius: 5
      },
      searchExamTypes: ['Exam'],
      searchQuestionRefs: ['Chart, Image, Formula']
    };
  },
  watch: {
    showAnnotations(show) {
      if (show) {
        this.renderAnnotationsLayer();
      }
    },
    currentPage() {
      if (this.showAnnotations) {
        this.selectedAnnotationName = null;
        this.updateTransformer();
        this.renderAnnotationsLayer();
      }
    },
    layerAnnotations(rects) {
      // locate and update question position
      this.syncAnnotationPosition(rects);
    },
    selectedAnnotationName(name) {
      const index = this.layerAnnotations.findIndex(r => r.name === name);

      if (index < 0) {
        this.selectedAnnotation = null;
        return;
      }
      const rect = this.layerAnnotations[index];
      this.selectedAnnotation = this.getAnnotation(rect.id);
    },
    allPagesAnnotations() {
      this.allQuestions = this.getAllQuestions();
    }
  },
  components: {
    pdf,
    StandardSearch,
    ChooseResource
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
    pageAnnotations() {
      const selectedPage = this.allPagesAnnotations.find(
        item => item.page == this.currentPage
      );
      if (selectedPage) {
        return selectedPage.annotations;
      } else {
        return [];
      }
    },
  },
  methods: {
    pageLoaded(pageNumber) {
      this.currentPage = pageNumber;

      const x = this.$refs.pdfContainer.clientWidth;
      const y = this.$refs.pdfContainer.clientHeight;

      this.configKonva.width = x;
      this.configKonva.height = y;
      this.pdfLoading = false;
    },
    syncAnnotationPosition(rects) {
      //update root data, sync position with main datasource
      const selectedIndex = this.allPagesAnnotations.findIndex(
        item => item.page == this.currentPage
      );

      //skip if no page is selected
      if (selectedIndex < 0) {
        return;
      }

      const selectedPage = this.allPagesAnnotations[selectedIndex];

      rects.forEach(rect => {
        const annotationIndex = selectedPage.annotations.findIndex(
          q => q.number === rect.number
        );

        const x = rect.x;
        const y = rect.y;
        const width = rect.width * (rect.scaleX || 1);
        const height = rect.height * (rect.scaleY || 1);

        //Add question if not exist
        if (annotationIndex < 0) {
          const question = "N/A";
          const newQuestion = {
            question,
            number: rect.number,
            id: rect.id,
            position: { x, y, width, height }
          };
          selectedPage.annotations.push(newQuestion);
        } else {
          // find question
          selectedPage.annotations[annotationIndex].position.x = x;
          selectedPage.annotations[annotationIndex].position.y = y;
          selectedPage.annotations[annotationIndex].position.width = width;
          selectedPage.annotations[annotationIndex].position.height = height;
        }
      });

      //Redraw layer
      if (this.$refs.annotationLayer) {
        this.$refs.annotationLayer.getNode().draw();
      }
    },
    renderAnnotationsLayer() {
      //Reset layer
      this.layerAnnotations = [];
      this.layerTexts = [];

      const width = this.configKonva.width;
      const height = this.configKonva.height;

      let selectedPage = this.allPagesAnnotations.find(
        item => item.page === this.currentPage
      );

      //add new page if not exists
      if (!selectedPage) {
        selectedPage = {
          page: this.currentPage,
          width,
          height,
          annotations: []
        };
        this.allPagesAnnotations.push(selectedPage);
      }

      if (selectedPage && selectedPage.annotations) {
        //map annotations to rects and text layer
        const rects = selectedPage.annotations.map(q => {
          return Object.assign(
            {
              name: `annotation_${q.number}`,
              number: q.number,
              id: q.id,
              type: q.type,
              x: q.position.x,
              y: q.position.y,
              width: q.position.width,
              height: q.position.height,
              fill: Konva.Util.getRandomColor()
            },
            this.rectTemplate
          );
        });

        this.layerAnnotations = rects;
      }
    },
    dragMove() {
      if (this.selectMode === 1 && this.addingRect) {
        const stage = this.$refs.stage;
        const mousePos = stage.getNode().getPointerPosition();

        //expand block size based on mouse position
        if (this.selectedAnnotationName) {
          const rectIndex = this.layerAnnotations.findIndex(
            r => r.name === this.selectedAnnotationName
          );
          if (rectIndex > -1) {
            const rect = this.layerAnnotations[rectIndex];
            rect.width = mousePos.x - rect.x;
            rect.height = mousePos.y - rect.y;
            //update layer
            this.layerAnnotations.splice(rectIndex, 1, rect);
          }
        }
        //Create new rect
        else {
          let newRect = Object.assign({}, this.rectTemplate);
          const newIndex = this.layerAnnotations.length + 1;
          newRect.name = "annotation_" + newIndex;
          newRect.id = newIndex;
          newRect.number = newIndex;
          newRect.x = this.startPosition.x;
          newRect.y = this.startPosition.y;
          newRect.width = 100;
          newRect.height = 50;
          newRect.fill = Konva.Util.getRandomColor();
          this.layerAnnotations.push(newRect);
          this.selectedAnnotationName = newRect.name;
        }
      }
    },
    dragEnd(e) {
      const group = e.target;
      const groupRect = group.children[1];
      const newPos = groupRect.getAbsolutePosition();
      // Find element in stage and update new position
      const rectIndex = this.layerAnnotations.findIndex(
        r => r.name === this.selectedAnnotationName
      );

      const rect = this.layerAnnotations[rectIndex];
      rect.x = newPos.x;
      rect.y = newPos.y;

      this.layerAnnotations.splice(rectIndex, 1, rect);
    },
    handleStageMouseUp() {
      if (this.addingRect) {
        // this.selectedAnnotationName = null;
        if (this.selectedAnnotationName) {
          this.showEditAnnotation = true;
        }
        this.addingRect = false;
      }
    },
    handleTransformEnd(e) {
      if (!this.selectedAnnotationName) {
        return;
      }

      // shape is transformed, let us save new attrs back to the node
      // find element in our state
      const rect = this.layerAnnotations.find(
        r => r.name === this.selectedAnnotationName
      );

      //skip if not found
      if (!rect) {
        return;
      }

      const group = e.target;
      // const groupRect = group.children[1];

      // update the state
      rect.x = group.x();
      rect.y = group.y();
      rect.rotation = group.rotation();
      rect.scaleX = group.scaleX();
      rect.scaleY = group.scaleY();

      // change fill
      rect.fill = Konva.Util.getRandomColor();

      //Update layerAnnotations with new values, to trigger watch on the variable
      this.layerAnnotations.splice(
        this.layerAnnotations.findIndex(
          r => r.name === this.selectedAnnotationName
        ),
        1,
        rect
      );

      // const transformerNode = this.$refs.transformer.getNode();
      // transformerNode.getLayer().batchDraw();
    },
    handleStageMouseDown(e) {
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedAnnotationName = "";
        this.updateTransformer();

        if (this.selectMode === 1) {
          // new selection mode started
          this.addingRect = true;

          const stage = this.$refs.stage;
          const mousePos = stage.getNode().getPointerPosition();
          this.startPosition.x = parseInt(mousePos.x);
          this.startPosition.y = parseInt(mousePos.y);
        }

        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === "Transformer";
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      const rect = this.layerAnnotations.find(r => r.name === name);
      if (rect) {
        this.selectedAnnotationName = name;
      } else {
        this.selectedAnnotationName = "";
      }
      this.updateTransformer();
    },
    updateTransformer() {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedAnnotationName } = this;

      const selectedNode = stage.findOne("." + selectedAnnotationName);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        const group = selectedNode.parent;
        // attach to another node
        transformerNode.nodes([group]);
      } else {
        // remove transformer
        transformerNode.detach();
      }
      transformerNode.getLayer().batchDraw();
    },
    enterStage() {
      const stage = this.$refs.stage;
      if (this.selectMode === 1) {
        stage.getNode().container().style.cursor = "crosshair";
      } else {
        stage.getNode().container().style.cursor = "pointer";
      }
    },
    leaveStage() {
      const stage = this.$refs.stage;
      stage.getNode().container().style.cursor = "default";
    },
    enterRect() {
      const stage = this.$refs.stage;
      stage.getNode().container().style.cursor = "move";
    },
    leaveRect() {
      const stage = this.$refs.stage;
      stage.getNode().container().style.cursor = "default";
    },
    delAnnotation() {
      if (this.selectedAnnotationName) {
        const index = this.layerAnnotations.findIndex(
          r => r.name === this.selectedAnnotationName
        );
        const rect = this.layerAnnotations[index];

        const selectedPageIndex = this.allPagesAnnotations.findIndex(
          item => item.page == this.currentPage
        );
        const annotationIndex = this.allPagesAnnotations[
          selectedPageIndex
        ].annotations.findIndex(q => q.number === rect.number);

        if (index >= 0) {
          //remove selected and transformer
          this.selectedAnnotationName = null;
          const transformerNode = this.$refs.transformer.getNode();
          transformerNode.detach();

          this.layerAnnotations.splice(index, 1);

          //delete from annotations
          this.allPagesAnnotations[selectedPageIndex].annotations.splice(
            annotationIndex,
            1
          );
        }
      }
    },
    updateAnnotation() {
      this.showEditAnnotation = false;
      this.renderAnnotationsLayer();
    },
    getAllQuestions() {
      let allQuestions = [];
      this.allPagesAnnotations.forEach(item => {
        allQuestions.concat(item.annotations);
      });
      return allQuestions;
    },
    getAnnotation(id) {
      const selectedPageIndex = this.allPagesAnnotations.findIndex(
        item => item.page == this.currentPage
      );

      if (selectedPageIndex > -1) {
        const page = this.allPagesAnnotations[selectedPageIndex];
        const annotationIndex = page.annotations.findIndex(a => a.id === id);
        return this.allPagesAnnotations[selectedPageIndex].annotations[
          annotationIndex
        ];
      } else {
        return null;
      }
    },
    setAnnotation(annotation) {
      console.log(`set annotation ${JSON.stringify(annotation)}`);
    },
    linkReferences() {
      alert("Link references, coming soon.");
    },
    linkStandard() {
      this.showLinkStandards = true;
    },
    addStandards(event, ccStandardIds) {
      console.log("event added standards triggered");
      console.log(ccStandardIds);
      console.log(event.target);
    },
    startStandardsSearch() {
      console.log("start standards search");
    },
    loadSelectedFile(file) {
      this.pdfLoading = true;
      const srcId = file.materialId;
      const pdfPath = `${process.env.VUE_APP_BASE_URL}/s3/get/${srcId}`;

      this.pdfSrc = this.createPdfLoadingTask(pdfPath);
      this.currentPage = 1;

    },
    createPdfLoadingTask(src, options) {
      var source;
      if ( typeof(src) === 'string' )
        source = { url: src, withCredentials: true, disableFontFace: true };
      else if ( src instanceof Uint8Array )
        source = { data: src, withCredentials: true, disableFontFace: true };
      else if ( typeof(src) === 'object' && src !== null )
        source = Object.assign({withCredentials: true, disableFontFace: true}, src);
      else
        throw new TypeError('invalid src type');

      // source.verbosity = PDFJS.VerbosityLevel.INFOS;
      // source.pdfBug = true;
      // source.stopAtErrors = true;

      var loadingTask = PDFJS.getDocument(source);
      
      loadingTask.__PDFDocumentLoadingTask = true; // since PDFDocumentLoadingTask is not public

      if ( options && options.onPassword )
        loadingTask.onPassword = options.onPassword;

      if ( options && options.onProgress )
        loadingTask.onProgress = options.onProgress;

      loadingTask.promise.then(() => {}).catch(e => { console.log(e); });

      return loadingTask;
    }
  },
  mounted: function() {
    this.pdfSrc = this.createPdfLoadingTask('/pdf/demo.pdf');
    // console.log(this.$refs.pdfComponent.pdf);
    if (this.showAnnotations) {
      this.renderAnnotationsLayer();
    }
  }
};
</script>

<style>
</style>
